// src/components/layout/AppLayout.jsx
import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import MenuButton from "../../components/MenuButton";
import NavSidebar from "../nav/NavSidebar";
import styles from "./AppLayout.module.css";

export default function AppLayout() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const showMenu = location.pathname !== "/";

  return (
    <div className={styles.layout}>
      {showMenu && (
        <>
          <div style={{ position: "fixed", top: 14, left: 14, zIndex: 1100 }}>
            <MenuButton onClick={() => setOpen(true)} />
          </div>
          <NavSidebar open={open} onClose={() => setOpen(false)} />
        </>
      )}

      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
}
